import React from "react";
import ReactDOM from "react-dom/client";
import { AnimatePresence } from "framer-motion";
import { Analytics } from "@vercel/analytics/react";
import Layout from "./src/components/Layout/Layout";
import "./src/styles/global.css";

export const onClientEntry = () => {
  document.documentElement.lang = "en";
};

export const replaceHydrateFunction = () => {
  return (element, container) => {
    const root = ReactDOM.createRoot(container);
    root.render(element);
  };
};

export const wrapPageElement = ({ element, props }) => {
  console.log("wrapPageElement called with props:", props);
  return (
    <AnimatePresence mode="wait">
      <Layout {...props} key={props.path}>
        {element}
      </Layout>
      <Analytics />
    </AnimatePresence>
  );
};
